import type { RefObject } from "react";

import {
  buildExportSuccessMessage,
  resolveExportError,
  EXPORT_EMPTY_MESSAGE,
  EXPORT_EMPTY_SUMMARY,
} from "./export.service";
import type { UseFileExportOptions } from "./use-file-export";

type ExportFeedback = Pick<UseFileExportOptions, "onSuccess" | "onEmpty" | "onError">;

/** O que o feedback precisa do `Toast` do Prime (`ref` do componente): só `show`. */
export interface ToastLike {
  show(message: {
    severity: "success" | "info" | "error";
    summary: string;
    detail?: string;
    life: number;
    closable: boolean;
  }): void;
}

/** O `ref` do `Toast` do Prime ou a API do `useToast` do DS (que também cabe em `ToastLike`). */
export type ExportToast = RefObject<ToastLike | null> | ToastLike;

const toastDe = (toast: ExportToast) => ("current" in toast ? toast.current : toast);

/** Retorno da exportação em mensagens, iguais nas listagens do Hub (AC3). */
export function createExportFeedback(toast: ExportToast): ExportFeedback {
  return {
    onSuccess: (_fileName, format) =>
      toastDe(toast)?.show({
        severity: "success",
        summary: buildExportSuccessMessage(format),
        life: 3000,
        closable: true,
      }),
    onEmpty: () =>
      toastDe(toast)?.show({
        severity: "info",
        summary: EXPORT_EMPTY_SUMMARY,
        detail: EXPORT_EMPTY_MESSAGE,
        life: 4000,
        closable: true,
      }),
    onError: (error: unknown, format) => {
      const { summary, detail } = resolveExportError(error, format);

      toastDe(toast)?.show({ severity: "error", summary, detail, life: 5000, closable: true });
    },
  };
}
